import { Routes } from 'react-router-dom';
import { GlobalProtectedRoute } from 'framework/authorization';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';
import { GET_ACCOUNTING_CYCLE } from './useAccountingCycle';
import {
  getAccountingCycleListUrl,
  getAccountingCycleRouterPath,
  useAccountingCycleRoute,
} from './shared/useAccountingCycleRouting';
import AccountingCycleList from './List';
import ShowAccountingCycle from './Show/ShowAccountingCycle';

const AccountingCycleRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute, singleEntityRoute } = useAccountingCycleRoute();

  return (
    <ProtectedRouter basePath={getAccountingCycleListUrl()}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={GET_ACCOUNTING_CYCLE}>
              <AccountingCycleList />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={singleEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={GET_ACCOUNTING_CYCLE}>
              <ShowAccountingCycle />
            </GlobalProtectedRoute>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

AccountingCycleRouter.getRouterPath = getAccountingCycleRouterPath;

export default AccountingCycleRouter;
